import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  item: {
    display: 'flex',
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '15px',
  },
  modalSubTitle: {
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
    marginBottom: '25px',
  },
}));
